<header>
    <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light">
      <div class="container page-container-yk">
        <img class="img-logo" [src]="logoSrc"/>
      </div>
    </nav>
  </header>
  